navigation();
// welcomeNewsletter();
cookiePolicy();
showHideSearch();
showHideNewsletter();
productQuantity();
scrollEvents(); 
ScrollOut();
showBanksyNewsletter();
colorSwatches();

setTimeout(function() {
//   quickview();
  newquickview();
  addToCart();
}, 1000)

const store_currency = '£';

if (parseInt($(window).width()) < 768) {
  footerAccordion();
  topbarReadMoreLess();
}

function navigation() {
  var menu_icon = $('.menu-icon .menu'),
      close_icon = $('.menu-icon .close'),
    nav_container = $('.new-menu'),
    header = $('.header-menu');

  menu_icon.on('click', function() {
    header.addClass('--active'); 
    nav_container.addClass('--active');
  });
  close_icon.on('click', function() {
    header.removeClass('--active'); 
    nav_container.removeClass('--active');
    $('.new-menu .has-child').removeClass('--active')
  });
  
  $('.new-menu .has-child > a').on('click', function(e){
    e.preventDefault();
    $('.new-menu .has-child').removeClass('--active')
    $(this).parent().addClass('--active')
  })
}

function topbarReadMoreLess() {
  var showChar = 100, 
    moretext = "Read More",
    lesstext = "Read Less",
    topbar = $('.topbar');
    

    topbar.each(function() {
    var content = $(this).html(),
      textcontent = $(this).text();

    if (textcontent.length > showChar) {
      var c = textcontent.substr(0, showChar);
      var html = '<span class="container"><span class="initial-content">' + c + '</span>' + '</span><span class="morecontent">' + content + '</span><a href="" class="morelink">' + moretext + '</a>';
      $(this).html(html);
    }
	});

	$(".morelink").click(function() {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      topbar.removeClass("more");
      $(this).html(moretext);
      $(this).children('.morecontent').fadeToggle(500, function(){
        $(this).prev().fadeToggle(500);
      });
    } else {
      $(this).addClass("less");
      topbar.addClass("more");
      $(this).html(lesstext);
        $(this).children('.container').fadeToggle(500, function(){
          $(this).next().fadeToggle(500);
        });
    }
    return false;
	});
}

function footerAccordion() {
  var footer_accordion_title = $('.accordion .title'),
    footer_content = $('.accordion .footer-content');

  footer_accordion_title.on('click', function() {
      footer_accordion_title.removeClass('active');
      $(this).addClass('active');
      footer_content.slideUp().removeClass('active');
      $(this).next().slideDown().addClass('active');
  });
}

function addToCart() {
  $('.add-to-cart').on('click', function() {
    const addToCartForm = $(this).parent(),
      messageContainer = $('.message_main-container');

    messageContainer.removeClass('--success');
    messageContainer.removeClass('--fail');
    event.preventDefault();
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      data: $(addToCartForm).serialize(),
      success: addToCartSuccess,
      error: addToCartFail
    });
  });
}

function addToCartSuccess() {
  const cartCount = $('.mini_cart-count'),
    messageContainer = $('.message_main-container');

  $.ajax({
    type: 'GET', 
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function(data) {
      cartCount.html(`${data.item_count}`);
      messageContainer.addClass('--success').html('<span>Product has been successfully added to <a href="/cart">cart</a></span>');
    },
  });

  if($('html').hasClass('--no-scroll')) {
    $('html').removeClass('--no-scroll');
    $('.quick_view-container').removeClass('--active');
  }
}

function addToCartFail(req, err) {
  const messageContainer = $('.message_main-container');
  $.ajax({
    type: 'GET', 
    url: '/cart.js',
    dataType: 'json',
    cache: false,
    success: function(data) {
      messageContainer.addClass('--fail').html(`<span>Sorry we currently have only ${data.item_count} of this product in stock</span>`);
    },
  });
}

function cookiePolicy() {
  const policy_button = $('.cookie_collect-container button'),
    policy_container = $('.cookie_collect-container');

    setTimeout(function () {
      policy_container.addClass('--show')
    }, 2000);

  policy_button.on('click', function() {
    policy_container.addClass('--accepted');
    localStorage.setItem("cookiesAccepted", "accepted");
  });

  if(localStorage.cookiesAccepted == "accepted") {
    policy_container.addClass('--accepted');
  }
}

function welcomeNewsletter() {
  const wn_close_button = $('.welcome_newsletter .close-button'),
    wn_container = $('.welcome_newsletter');

  if(localStorage.welcome_newsletter !=="closed" ) {
    setTimeout(function () {
      wn_container.addClass('--show')
    }, 2000);
  }

  wn_close_button.on('click', function() {
    wn_container.removeClass('--show');
    localStorage.setItem("welcome_newsletter", "closed");
  });
}

function showHideNewsletter() {
  const newsletter_toggle = $('.newsletter-toggle'),
  newsletter_button = $('.newletter-form form .button'),
  newletter_form = $('.newletter-form'),
  mailchimp_form = $('.newletter-form form');

  newsletter_toggle.on('click', function(){
    newletter_form.toggleClass('--active');
  });

  newsletter_button.on('click', function(){
    newletter_form.removeClass('--active');

    setTimeout(function() {
      mailchimp_form.trigger("reset");
    }, 1000)
  });  
}

function quickview() {
  var quickview_trigger = $('.quick_view-tigger'),
    quickview_popup = $('.quick_view-container'),
    html = $('html'),
    product_container = $('.quick_view-container .product-container'),
    variant_select = $('.quick-variant_select'),
    close = $('.quick_view-container .close-button');
    
  quickview_trigger.on('click', function() {
    var getProduct_id = $(this).attr('data-url'),
      getProduct_json = '/products/'+getProduct_id+'.js';

    quickview_popup.addClass('--active');
    html.addClass('--no-scroll');

    jQuery.getJSON(getProduct_json, function (product) {
      var product_name = product.title,
        get_price = product.price,
        desc = product.description,
        variants = product.variants,
        variant_count = variants.length,
        images = product.images,
        image_count = $(images).length,
        product_price = 0,
        first_variant = variants[0].available;
        product_price = parseFloat(get_price / 100).toFixed(2);

      addGallery();
      addVariants();
      addInfo();

      function addGallery() {
        $(images).each(function (i, image) {
          if (i !== image_count) {
            var image_embed = ' <div class="swiper-slide card-item"><img src="' + image + '"></div>';
            image_embeded = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
            $('.quick_view-container .swiper-wrapper').append(image_embeded);
          }
        });

        var swiper = new Swiper('.product_image-container', {
          loop: true,
          pagination: {
            el: '.product-pagination',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }

      function addVariants() {
        $(variants).each(function (i, variant) {
          var get_price = variant.price,
            variant_price = parseFloat(get_price / 100).toFixed(2);

          if(variant.available === true ) {
            var variant_embed = '<option value=' + variant.id + ' product-price=' + variant_price + '>' + variant.title + ' - ' + store_currency + variant_price + '</option>';
            variant_select.append(variant_embed);

            variant_select.on('change', function() {
              event.preventDefault(); 
              var get_current_price = $('.quick-variant_select option:selected').attr('product-price');
              $('.quick-price').html(store_currency + get_current_price);
            });
          }
          else {
            var variant_embed = '<option disabled="disabled">' + variant.title + ' - sold out </option>';
            variant_select.append(variant_embed);
          }

          if (variant_count < 2) {
            variant_select.css('display', 'none'); 
          }
        });
      }

      function addInfo() {
        $('.quick-name').text(product_name);
        $('.quick-desc').html(desc);

        if(first_variant === false) {
          $('.quick-price').text(store_currency + product_price).addClass('--no-stock');
          $('.quick-add').removeClass('add-to-cart').text('out of stock').attr('disabled', true);
          $('.qty-container').css('display', 'none');
        }
        else {
          $('.quick-price').text(store_currency + product_price);
          $('.quick-nostock').css('display', 'none');
        }
        product_container.css('opacity', '1');
      }
    });
  });

  close.on('click', function() {
    quickview_popup.removeClass('--active');
    html.removeClass('--no-scroll')
    resetQuickview();

    function resetQuickview() {
      $('.quick_view-container .swiper-wrapper, .quick-price, .quick-name, .quick-desc, .quick-variant_select').html('');
      product_container.css('opacity', '0');
      $('.quick_view-container .swiper-wrapper, .quick-variant_select, .quick_view-container .qty-container').removeAttr("style");
      $('.quick-add').removeAttr('disabled').text('add to bag');
      $('.quick-qty').val('1'); 
    }
  });
}

function productQuantity() {
  $('.qty-plus').click(function(e){
    e.preventDefault();
    qty_field = $(this).parent().children('.qty-field');
    qty_value = parseInt(qty_field.val());
    if(!isNaN(qty_value) && qty_value > 0) {
      +qty_field.val(qty_value + 1);
    }
    else {
      +qty_field.val('1');
    }
  });
  
  $(".qty-minus").click(function(e) {
    e.preventDefault();
    qty_field = $(this).parent().children('.qty-field');
    qty_value = parseInt(qty_field.val());
    if(!isNaN(qty_value) && qty_value > 0) {
      +qty_field.val(qty_value - 1);
    }
    else {
      +qty_field.val('0');
    }
  });
}

function scrollEvents() {
  const win = $(window);
    win_height = 300,
    message_bar = $('.message_main-container');

  win.on('scroll', function () {
    if ($(this).scrollTop() > win_height ) {
      message_bar.addClass('--scroll');
    } else {
      message_bar.removeClass('--scroll');
    }
  });
}

function showHideSearch() {
  $('.search_icon--desktop').on('click', function() {
    $('.search_box-container').addClass('--active');
    $('.search_box-container .search-box').val('').focus();
  }); 
  
  $('.search_box-container .search-box').focusout(function () {
    setTimeout(function () {
      $('.search_box-container').removeClass('--active');
    }, 1000);
  });
  
  $(document).on( 'keydown', function ( e ) {
    if ( e.keyCode === 27 ) { // ESC
      $('.search_box-container').removeClass('--active');
    }
  });
}

function showBanksyNewsletter() {
  var trigger = $('.news_signup_trigger'),
    news_signup_popup = $('.news_signup-container'),
    signup_close_button = $('.news_signup-container .close-button');

  trigger.on('click', function() {
    news_signup_popup.addClass('--active');
  });

  signup_close_button.on('click', function() {
    news_signup_popup.removeClass('--active');
    $('.mc-field-group input').val('');
  });
}

function newquickview() {
	var quickview_trigger = $('.quick_view-tigger'),
      quickview_popup = $('.quick_view-container'),
      html = $('html'),
      product_container = $('.quick_view-container .product-container'),
      variant_select = $('.quick-variant_select'),
      quickview_content = $('.ajax-content'),
      close = $('.quick_view-container .close-button');

  quickview_trigger.click(function(e){
    e.preventDefault();
    var getProduct_id = $(this).attr('data-url'),
        getProduct_json = '/products/'+getProduct_id;

    quickview_popup.addClass('--active');
    html.addClass('--no-scroll');
    $.ajax({
      type: "GET",
      url: getProduct_json,
      data: { },
      success: function(data){
        $('.ajax-content').html($(data).find('.product-container_quick').html());
      }
    });
  });
  
  close.on('click', function(){
  	html.removeClass('--no-scroll');
    quickview_popup.removeClass('--active');
    quickview_content.empty();
  });
  
  console.log('Developed with ❤️ + ☕ || Another ONE by Jayanetty [https://jayanetty.com/]');
}

function colorSwatches() {
  $('.card-item .product-option-colour li').on('click', function(){
    $(this).siblings().removeClass('selected')
    $(this).addClass('selected')
    $(this).parent().siblings('.get_product-id').val($(this).data('id'))
    $(this).parents('.card-item').children('.item-image').children('.hover').attr('src', $(this).data('img'))
  })

  $('.card-item select').on('change', function() {
    $(this).parent().children('.get_product-id').val($(this).find(":selected").data('id'))
  })
}